import { Select } from "antd";
import type { FC } from "react";

import type { DynamicPropertyEntity } from "src/app/features/DynamicProperty/types/DynamicPropertyEntity";
import type { DynamicPropertyGroupEntity } from "src/app/features/DynamicPropertyGroup/types/DynamicPropertyGroupEntity";
import { SelectInput } from "../../../Select/SelectInput";
import { TextInput } from "../Text/TextInput";

interface PropertyGroupSelectorProps {
    onSelect: Function;
    readOnly: boolean;
    dynamicProperty?: DynamicPropertyEntity;
    options: DynamicPropertyGroupEntity[];
    isLoading?: boolean;
}

export const PropertyGroupSelector: FC<PropertyGroupSelectorProps> = ({ onSelect, readOnly, dynamicProperty, options, isLoading }) => {
    const onValueChange = (selectedOption: string) => {
        if (!selectedOption) {
            onSelect(undefined);
        }
        onSelect(selectedOption);
    };

    return readOnly ? (
        <TextInput readOnly label="" name="" data-name="selected_property_group" value={dynamicProperty?.name} />
    ) : (
        <div data-name="property_group_selector">
            <SelectInput isLoading={isLoading} disabled={readOnly} onChange={onValueChange} value={dynamicProperty?.id as string}>
                {options.map((option: DynamicPropertyGroupEntity) => {
                    const optionLabel = `${option.name} (${option.id})`;
                    return (
                        <Select.Option key={option.id} value={option.id} displayName={optionLabel}>
                            {optionLabel}
                        </Select.Option>
                    );
                })}
            </SelectInput>
        </div>
    );
};
